import React from "react";
import { Tooltip } from "antd";
import LogisticsCompany from "@/enum/LogisticsCompany";
import { getFirstValidTrackingUrl } from "@/services/trackingUrl";

interface LastLogisticsActivityProps {
    logisticsCompany?: LogisticsCompany;

    waybillNo?: string;

    lastLogisticsActivity?: string;

    lastLogisticsActivityTime?: string;
}

/**
 * 最新物流轨迹显示
 */
const LastLogisticsActivity: React.FC<LastLogisticsActivityProps> = function (props) {
    const { lastLogisticsActivity, lastLogisticsActivityTime, logisticsCompany, waybillNo } = props;

    if (!lastLogisticsActivity) {
        return null;
    }

    const title = `${lastLogisticsActivity} ${lastLogisticsActivityTime || ""}`;

    const result = getFirstValidTrackingUrl(logisticsCompany, waybillNo);

    return (
        <Tooltip title={title}>
            <p>
                {result ? (
                    <a
                        target="_blank"
                        href={result.url}
                        rel="noopener noreferrer"
                        className="logistics-activity text-light show-tooltip"
                    >
                        {lastLogisticsActivity}
                    </a>
                ) : (
                    lastLogisticsActivity
                )}
            </p>
        </Tooltip>
    );
};

export default React.memo(LastLogisticsActivity);
